import { useEffect, useState } from "react";
import { getCachedConfiguration } from "utils/functions/configurationUtil";
import * as c from "./Booster.module.css";

function Booster() {
  const configuration = getCachedConfiguration();
  const [timeLeft, setTimeLeft] = useState<{ days: number; hours: number; minutes: number }>({
    days: 0,
    hours: 0,
    minutes: 0,
  });

  const parseUtc = (date: string) => new Date(date.endsWith("Z") ? date : `${date}Z`).getTime();

  const activeSale = configuration?.offersCurrencySale;
  const endOn = activeSale?.endOn;
  const multiplier = activeSale?.multiplier;

  useEffect(() => {
    if (!endOn) {
      setTimeLeft({ days: 0, hours: 0, minutes: 0 });
      return;
    }

    const updateTimer = () => {
      const diffMs = parseUtc(endOn) - Date.now();

      if (diffMs <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0 });
        return;
      }

      const totalMinutes = Math.floor(diffMs / 60000);
      const totalHours = Math.floor(totalMinutes / 60);

      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;
      const minutes = totalMinutes % 60;

      setTimeLeft({ days, hours, minutes });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 60000);

    return () => clearInterval(interval);
  }, [endOn]);

  if (!activeSale) return null;

  return (
    <div className={c["booster-container"]}>
      <div className={c["multiplyer"]}>
        <span>{multiplier}x</span>
      </div>
      <div className={c["info"]}>
        <div className={c["info-text"]}>
          <span>Limited-Time Bonus</span>
        </div>
        <div className={c["info-time"]}>
          {timeLeft.days > 0 && (
            <>
              <span className={c["time"]}>{timeLeft.days}d</span>&nbsp;
              <span className={c["separator"]}>:</span>&nbsp;
            </>
          )}
          <span className={c["time"]}>{timeLeft.hours}hr</span>&nbsp;
          <span className={c["separator"]}>:</span>
          &nbsp;<span className={c["time"]}>{timeLeft.minutes}m</span>
          &nbsp;<span className={c["text"]}>Remaining</span>
        </div>
      </div>
    </div>
  );
}

export default Booster;
